import React, { FunctionComponent, useState, useRef } from 'react';
import { View, Text, PlayIcon } from '@upstox/upstox-ui';
import * as css from './IPOAnalysis.style';
import { getEmbedUrl } from '../helpers';
import Slider from './Slider';
import Head from 'next/head';

type Props = {
  seoName: string;
  seoMeta: { desc?: string; title?: string };
  videoUploadDate: string;
  videoDuration: string;
  logoLink: string;
  ipoVideoLink: string;
  sliderImages?: {
    alt?: string;
    url?: string;
    title?: string;
  }[];
  showHeading?: boolean;
};
const IPOAnalysis: FunctionComponent<Props> = ({
  seoName,
  seoMeta,
  videoUploadDate,
  videoDuration,
  logoLink,
  ipoVideoLink,
  sliderImages,
  showHeading = true,
}) => {
  const videoUrl = getEmbedUrl(ipoVideoLink);
  const videoSchemaTag = JSON.stringify({
    '@context': 'https://schema.org',
    '@type': 'VideoObject',
    name: seoMeta?.title,
    description: seoMeta?.desc,
    thumbnailUrl: logoLink,
    uploadDate: videoUploadDate,
    duration: videoDuration,
    publisher: {
      '@type': 'Organization',
      name: 'Upstox',
      logo: {
        '@type': 'ImageObject',
        url: 'https://assets.upstox.com/common/images/upstox-logo-primary.svg',
        width: 58,
        height: 18,
      },
    },
    contentUrl: `${process.env.BASE_URL}/ipo-initial-public-offering/${seoName}`,
    embedUrl: videoUrl,
  });

  return (
    <>
      {videoUrl && (
        <Head>
          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{
              __html: videoSchemaTag,
            }}
          ></script>
        </Head>
      )}
      <View flexDirection="column" css={css.ipoAnalysis}>
        {showHeading && (
          <View css={css.title}>
            <Text variant="bodyBold" as={'h2'}>
              IPO analysis
            </Text>
          </View>
        )}

        {videoUrl && videoUrl.length > 0 && (
          <View flexDirection="column">
            <Text variant="bodyBold">All you need to know!</Text>

            <View css={css.videoWrapper} className="mb30">
              <object className="full-width" style={{ borderRadius: '8px' }}>
                <param name="movie" value={videoUrl} />
                <param name="allowFullScreen" value="true" />
                <param name="allowscriptaccess" value="always" />
                <param name="autoplay" value="true" />
                <embed
                  src={videoUrl}
                  type="text/html"
                  className="full-width full-height"
                />
              </object>
            </View>

            {/* ToDo custom play button  */}
            {/* <View css={css.playButton} alignContent="center" justifyContent="center"></View> */}
          </View>
        )}

        {sliderImages &&
          sliderImages?.length > 0 &&
          videoUrl &&
          videoUrl.length > 0 && (
            <Text variant="bodyBold" className="mb10" as={'h2'}>
              Factoids
            </Text>
          )}

        {sliderImages && sliderImages?.length > 0 && (
          <Slider sliderImages={sliderImages} />
        )}
      </View>
    </>
  );
};

export default IPOAnalysis;
